import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SealidsReducer(state = initialState.budgetrefs, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETREFS_SUCCESS:
      return action.budgetrefs;
    default:
      return state;
  }
}
